/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { Middleware, Action } from 'redux'
import { C1Type } from '@redux/actions/types'
import {
  setExternalID,
  setTimeZone,
  setRegion,
  setRoleName,
  setHasAccessPermission,
  REGION_ACTION_TYPE,
  EXTERNAL_ID_ACTION_TYPE,
  ROLE_NAME_ACTION_TYPE,
  HAS_ACCESS_PERMISSION_TYPE,
} from '@redux/slices/common'

const REGION_MAP_LIST: Record<string, string> = {
  'us-east-1': 'us-1',
}

const queue: Action[] = []
const c1StateMiddleware: Middleware<any, Redux.RootState> =
  store => next => action => {
    const { dispatch, getState } = store
    const {
      c1Token: { token },
      common: { region, roleName, externalID, c1UserTimeZone },
    } = getState()

    if (
      action.type === C1Type.ADD_USER_INFO ||
      action.type === C1Type.STORE_INIT
    ) {
      const nextC1UserTimeZone =
        action.type === C1Type.STORE_INIT
          ? // @ts-ignore
            action.shellInitState?.c1UserDetails?.timezone
          : // @ts-ignore
            action.userDetails?.timezone

      if (!c1UserTimeZone && nextC1UserTimeZone) {
        dispatch(setTimeZone(nextC1UserTimeZone))
      }
    }
    if (action.type === C1Type.ADD_USER_INFO) {
      // @ts-ignore
      const nextC1AccountTimeZone = action.userDetails?.timezone

      if (nextC1AccountTimeZone && c1UserTimeZone !== nextC1AccountTimeZone) {
        dispatch(setTimeZone(nextC1AccountTimeZone))
      }
    }
    if (action.type === C1Type.STORE_C1_TOKEN) {
      // @ts-ignore
      const c1RoleSplit = action?.c1Token?.role?.split?.(':')
      // @ts-ignore
      const c1ServiceRoleName = action?.c1Token?.serviceRoleUrnList
        ?.find((serviceURN: string) => serviceURN.indexOf('filestorage') > -1)
        ?.split(':')?.[5]
        ?.replace('role/', '')
      const c1AccountID = c1RoleSplit?.[4]
      const c1Region = REGION_MAP_LIST[c1RoleSplit?.[3]] || c1RoleSplit?.[3]

      if (c1Region !== region) {
        dispatch(setRegion(c1Region))
      }
      if (c1AccountID !== externalID) {
        dispatch(setExternalID(c1AccountID))
      }
      if (c1ServiceRoleName !== roleName) {
        dispatch(setRoleName(c1ServiceRoleName))
        dispatch(setHasAccessPermission(!!c1ServiceRoleName))
      }
    } else if (
      action.type !== REGION_ACTION_TYPE &&
      action.type !== EXTERNAL_ID_ACTION_TYPE &&
      action.type !== ROLE_NAME_ACTION_TYPE &&
      action.type !== HAS_ACCESS_PERMISSION_TYPE
    ) {
      // Many of Redux actions might be relative to interact with API request.
      // Since the API domain has to compose with CloudOne Region and the token which are the value distributes from C1C Redux.
      // This queue collects the Redux actions before the API is ready to fetch.
      // Then dispatching the collected actions once API domain is composed.
      if (!region || !token) {
        queue.push(action)
      } else if (queue.length) {
        while (queue.length) {
          dispatch(queue.shift())
        }
      }
    }

    return next(action)
  }

export default c1StateMiddleware
